import React from "react";
import {Redirect} from "react-router-dom";

import {configMenuLinks} from "../../../config";
import {
  resolveProfileDestination,
} from "../../../presentation/user-profile/profile-destination";
import {userServices} from "../../../services";
import MainPage from "../main-page";

export default function HomePage() {
  const user = userServices.getUser();

  const userLinks = user.info.role in configMenuLinks
      ? configMenuLinks[user.info.role]
      : [];

  let homePage;

  if (user.loggedIn && !userLinks.length) {
    homePage = configMenuLinks.auth.find((link) => {
      return (
          link.homePage &&
          user.info.permissions.find((permission) => {
            if (Array.isArray(link.accessTo)) {
              return link.accessTo.find(
                  (accessItem) =>
                      permission.Name === accessItem
              );
            }

            return permission.Name === link.accessTo;
          })
      );
    });
  } else {
    homePage = userLinks.find(
        (link) => link.homePage === true
    );
  }

  if (homePage && user.loggedIn) {
    return <Redirect to={homePage.links[0]}/>;
  }

  if (!user.loggedIn) {
    return <MainPage/>;
  }

  return (
      <Redirect
          to={resolveProfileDestination(
              user.info,
              user.info.organization || {}
          )}
      />
  );
}
